export const environment = {
  production: true,
  buildId: '2808944424419191',
  configFile: 'config.json',
};
